import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold" }, "Frequenty Asked Questions", -1)
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text-left my-auto" }
const _hoisted_5 = {
  key: 0,
  class: "h-fit w-full px-5 pb-3"
}
const _hoisted_6 = ["innerHTML"]

import { ref } from "vue"
  import { useCompanyStore } from "@/store/company"
  import { useAuthenticationStore } from "@/store/authentication"
  import { add, removeOutline } from "ionicons/icons"
  import { IonIcon, IonTextarea, IonButton } from "@ionic/vue"
  import jwt from "@/utils/jwt"

  import CardTemplate from "@/components/template/CardTemplate.vue"

  interface FAQ {
    question: string
    answer: string
  }

  interface Props {
    details: FAQ[]
    submitButtonColor?: string
  }

  /**
   * Sends question to companies using sendQuestion()
   */
  
export default /*#__PURE__*/_defineComponent({
  __name: 'FaqContainer',
  props: {
    details: null,
    submitButtonColor: null
  },
  setup(__props: any) {

const props = __props as {
    details: FAQ[]
    submitButtonColor?: string
  }

  const input = ref("")
  const open = ref("")
  const showError = ref(false)
  const companyStore = useCompanyStore()

  const sendQuestion = () => {
    if (!localStorage.getItem("WBSAASAPP_TK")) useAuthenticationStore().authenticationWall = true
    // Checks if user is authenticated, if not show auth wall
    else if (input.value !== "") {
      showError.value = false
      companyStore.sendQuestion(input.value, companyStore.companyDetails.slug, jwt.generateNBF()).then((success) => {
        if (success) input.value = ""
      })
    }
  }

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardTemplate, null, {
    default: _withCtx(() => [
      _hoisted_1,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.details, (faqItem) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `${faqItem}_id`,
          class: "w-full"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "bg-light-gray-100 text-black flex justify-between px-3 py-3 rounded-base my-4 w-full",
              onClick: ($event: any) => (open.value = open.value == faqItem.question ? '' : faqItem.question)
            }, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(faqItem.question), 1),
              (open.value == faqItem.question)
                ? (_openBlock(), _createBlock(_unref(IonIcon), {
                    key: 0,
                    class: "w-14 text-3xl",
                    icon: _unref(removeOutline)
                  }, null, 8, ["icon"]))
                : (_openBlock(), _createBlock(_unref(IonIcon), {
                    key: 1,
                    class: "w-14 text-3xl",
                    icon: _unref(add)
                  }, null, 8, ["icon"]))
            ], 8, _hoisted_3),
            (open.value == faqItem.question)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("p", {
                    class: "text-left",
                    innerHTML: faqItem.answer
                  }, null, 8, _hoisted_6)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128)),
      _createVNode(_unref(IonTextarea), {
        modelValue: input.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event)),
        class: "bg-light-gray-100 text-black rounded-base px-4 h-24 mb-4",
        placeholder: "Send a question"
      }, null, 8, ["modelValue"]),
      _createVNode(_unref(IonButton), {
        expand: "block",
        color: "white",
        style: _normalizeStyle({ backgroundColor: __props.submitButtonColor || '#7442c8' }),
        class: "text-white font-bold rounded-[4px] shadow-base",
        disabled: !input.value.length,
        onClick: sendQuestion
      }, {
        default: _withCtx(() => [
          _createTextVNode("Submit")
        ]),
        _: 1
      }, 8, ["style", "disabled"])
    ]),
    _: 1
  }))
}
}

})